import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', lineHeight: '1.6' }}>
      <h1>개인정보 처리방침</h1>

      <div style={{ marginBottom: '30px' }}>
        <p><strong>최종 수정일: 2025년 9월 26일</strong></p>
      </div>

      <section style={{ marginBottom: '30px' }}>
        <h2>1. 개인정보의 처리 목적</h2>
        <p>도토리 저금통(Acorn Bank)은 다음의 목적을 위하여 개인정보를 처리합니다:</p>
        <ul>
          <li>회원가입 및 서비스 이용자 식별</li>
          <li>가족 간 미션 관리 및 용돈 정산 서비스 제공</li>
          <li>서비스 개선 및 맞춤형 서비스 제공</li>
          <li>고객상담 및 민원처리</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>2. 처리하는 개인정보의 항목</h2>
        <h3>필수항목</h3>
        <ul>
          <li><strong>부모:</strong> 이메일, 비밀번호, 이름</li>
          <li><strong>자녀:</strong> 이름, PIN(숫자 4자리)</li>
        </ul>
        <h3>자동 수집항목</h3>
        <ul>
          <li>서비스 이용 기록, 접속 로그, 접속 IP 정보</li>
          <li>미션 증빙 사진 (선택적 업로드)</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>3. 개인정보의 처리 및 보유기간</h2>
        <ul>
          <li>회원정보: 회원탈퇴 시까지</li>
          <li>미션 증빙 사진: 승인 시 정산 주 +7일, 반려/미승인 시 업로드 +7일 후 자동 삭제</li>
          <li>서비스 이용 기록: 3년</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>4. 개인정보의 제3자 제공</h2>
        <p>회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다:</p>
        <ul>
          <li>이용자들이 사전에 동의한 경우</li>
          <li>법령의 규정에 의거하거나, 수사 목적으로 법집행기관이 요구하는 경우</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>5. 개인정보처리의 위탁</h2>
        <ul>
          <li><strong>푸시 알림 서비스:</strong> Google Firebase (Google LLC)</li>
          <li><strong>웹호스팅 서비스:</strong> 자체 운영 (Synology NAS)</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>6. 정보주체의 권리·의무 및 행사방법</h2>
        <p>이용자는 언제든지 다음과 같은 개인정보 보호 관련 권리를 행사할 수 있습니다:</p>
        <ul>
          <li>개인정보 처리정지 요구권</li>
          <li>개인정보 열람요구권</li>
          <li>개인정보 정정·삭제요구권</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>7. 개인정보의 안전성 확보조치</h2>
        <ul>
          <li>개인정보 암호화 저장</li>
          <li>해킹 등에 대비한 기술적 대책</li>
          <li>개인정보에 대한 접근 제한</li>
          <li>접속기록의 보관 및 위변조 방지</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>8. 개인정보보호책임자</h2>
        <p>개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제를 처리하기 위하여 아래와 같이 개인정보보호책임자를 지정합니다.</p>
        <ul>
          <li><strong>담당자:</strong> 도토리 저금통 서비스 운영자</li>
          <li><strong>연락처:</strong> <a href="mailto:myid9734+acornban@gmail.com">myid9734+acornban@gmail.com</a></li>
        </ul>
      </section>

      <section>
        <h2>9. 개인정보 처리방침의 변경</h2>
        <p>본 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;